export default "__VITE_ASSET__BKShp$tZ__"